var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.145 21.145"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "streamline-icon-search@140x140",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5",
    d: "M3.89 12.536A6.592 6.592 0 107.38 3.89a6.592 6.592 0 00-3.489 8.645z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6",
    d: "M14.618 14.618l5.113 5.113"
  }))));
}

export default __webpack_public_path__ + "1d7fb35f7e3e905e895774dafa6078d8.svg";
export { SvgSearch as ReactComponent };